var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGradientbgone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1340,
    height: 1158,
    viewBox: "0 0 1340 1158",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 2058,
    height: 1158,
    transform: "translate(-718)",
    fill: "url(#paint0_radial_1_264)",
    fillOpacity: 0.35
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1_264",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1029 579) rotate(90) scale(579 1029)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6F30D8",
    stopOpacity: 0.44
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#261850",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGradientbgone);
export default __webpack_public_path__ + "static/media/gradientbgone.0d1489fa662e96aa9b26efe8e99149e4.svg";
export { ForwardRef as ReactComponent };